<template>
  <transition name="fade">
    <div v-if="isOpen" class="modal-wrapper payment-modal">
      <div class="modal-overlay" @click="close" />
      <div class="modal-box">
        <div class="modal-body">
          <div class="left-side">
            <transition name="fade" mode="out-in">
              <PricingBlock
                :creditsNeeded="state.creditsSelected"
                :isLoading="state.btnIsLoading"
                @changeCredits="(e) => (state.creditsSelected = e)"
                @next="startBuying()"
                @close="close"
              />
            </transition>
          </div>
          <div class="right-side">
            <InformationsBlock @close="close" />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { reactive, watch } from "vue";
import { useCompanyStore } from "@/stores/company.js";
import { useRoute } from "vue-router";
import { useToast } from "vue-toastification";
import { useAppStore } from "@/stores/app.js";
import { trackEventWithCallbackAndFallback } from "@/composables/analytics";
import InformationsBlock from "./block/InformationsBlock.vue";
import CompanyBlock from "./block/CompanyBlock.vue";
import PricingBlock from "./block/PricingBlock.vue";

const emits = defineEmits(["close"]);

const appStore = useAppStore();

const route = useRoute();

const toast = useToast();

const companyStore = useCompanyStore();

const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false,
  },
  creditsNeeded: {
    type: Number,
    default: 1,
  },
});

const state = reactive({
  btnIsLoading: false,
  editCompanyInfos: false,
  creditsSelected: props.creditsNeeded,
});

async function startBuying() {
  if (!appStore.isOnboarded) {
    if (window.confirm("Souhaitez-vous vraiment quitter l'onboarding ?")) {
      appStore.isOnboarded = true;
    } else {
      return;
    }
  }

  state.btnIsLoading = true;

  trackEventWithCallbackAndFallback(
    "checkout_progress",
    {
      value: state.creditsSelected,
    },
    async () => {
      const { url } = await companyStore.buyCompanyCredits(
        route.params.companyId,
        state.creditsSelected
      );

      if (url) {
        window.location.replace(url);
      } else {
        toast(
          "Un problème est survenue lors de la tentative d'achat, veuillez reéssayer plus tard.",
          {
            type: "error",
          }
        );
      }
    },
    5000
  );
}

function close() {
  localStorage.removeItem("pending_activations");
  state.creditsSelected = 1;
  emits("close");
}

watch(props, () => {
  if (props.isOpen) {
    document.querySelector("body").classList.add("noScroll");
  } else if (!props.isOpen) {
    document.querySelector("body").classList.remove("noScroll");
  }
});
</script>
